import { render, staticRenderFns } from "./ImageText.vue?vue&type=template&id=087fab07&"
import script from "./ImageText.vue?vue&type=script&lang=ts&"
export * from "./ImageText.vue?vue&type=script&lang=ts&"
import style0 from "./ImageText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports